import VueJwtDecode from "vue-jwt-decode";


export default new class {
    ROLE_ADMIN = "admin"

    constructor() {
        this.user = this.getCurrentUser()
    }

    isUserInGroup(groupName) {
        return this.getCurrentUser() && this.getCurrentUser().groups ? this.user.groups.includes(groupName) : false;
    }

    isAdmin() {
        //console.log("usermanager.js:isAdmin():", this.isUserInGroup("ADMIN") || this.isImpersonating())
        return this.isUserInGroup("ADMIN") && !this.isImpersonating()
    }

    isManager() {
        return this.isUserInGroup("MANAGER")
    }
    
    isPartner() {
        return this.isUserInGroup("PARTNER")
    }

    isAdminManagerOrPartner() {
        return this.isAdmin() || this.isManager() || this.isPartner()
    }

    isHost() {
        let isHost = this.getCurrentUser() ? this.getCurrentUser()['company.isHost'] : false;
        console.log("usermanager.js:isHost():", isHost)
        return isHost
    }

    isImpersonating() {
        let userToken = localStorage.getItem("impersonatedByToken")
        //console.log("isImpersonating:userId", userToken)
        if (userToken) return true
        return false
    }

    /**
     * @returns Actual user acting on this account
     */
    getAuthor() {
        let adminToken = localStorage.getItem("impersonatedByToken")
        
        if(adminToken) {
            return this.getUserByToken(adminToken)
        } else {
            let userToken = localStorage.getItem("jwt")
            return this.getUserByToken(userToken)
        }
    }

    exitImpersonate() {
        let userAdminToken = localStorage.getItem("impersonatedByToken")
        localStorage.removeItem("impersonatedByToken")
        return this.logUserIn(userAdminToken)
    }

    logUserIn(token) {
        if (token){
            localStorage.setItem("jwt", token)
            this.user = this.getCurrentUser()
            return true
        } 
        return false
    }

    impersonateUser(token, impersonatedByToken) {
        if(this.logUserIn(token)) {
          localStorage.setItem("impersonatedByToken", impersonatedByToken)
          return true
        }
        return false
    }

    getCurrentUser() {
        let token = localStorage.getItem("jwt")
        let user = this.getUserByToken(token)
        if(!user)
            console.warn("getCurrentUser", "Not logged in")
        return user
    }

    getUserByToken(token) {
        if(token) {
            let decoded = VueJwtDecode.decode(token);
            if(decoded.exp < Date.now()/1000 ) {
                console.warn("User token expired")
                localStorage.removeItem("jwt")
                return null
            } 
            var user = decoded;
            //console.log("userManager.js:getUserByToken", user)
            return user
        }
        return null
    }

    isUserLoggedIn() {
        if(!this.user) 
            this.user = this.getCurrentUser()
        
        if(!this.user) return false;

        // let token = localStorage.getItem("jwt");
        // if(token) {
        //     let decoded = VueJwtDecode.decode(token);
        //     this.user = decoded;
        //     console.log("userManager.js:isUserLoggedIn", this.user)
        //     return true
        // }
        return true
    } 
}